import type {CreateExtArgs} from '@wix/document-manager-core'

export const stateBoxMetaData = {
    isRepeatable: ({coreConfig}: CreateExtArgs) => coreConfig.experimentInstance.isOpen('dm_multiStateBoxInRepeater'),
    enforceContainerChildLimitsByWidth: true,
    enforceContainerChildLimitsByHeight: false
}
